import {useMemo} from 'react';
import {getFeatureFlags} from '@chekin/core';
import {useSettleWatchdog} from '@chekin/shared';
import {SPLASH_TIMING} from 'components/SplashScreen/constants';
import {useChekinSDK} from 'context/ChekinSDK';
import {
  DEFAULT_UI_VARIANT,
  UIVariant,
  UI_VARIANTS,
  applyUIVariantQueryOverride,
} from 'utils/uiVariant';

type UseUIVariantResult = {
  variant: UIVariant;
  isResolved: boolean;
};

export function useUIVariant(): UseUIVariantResult {
  const {isSuccessSDK, isAuthInitializationError, hasToken} = useChekinSDK();
  const isAuthSettled = isSuccessSDK || isAuthInitializationError;
  const isAuthWatchdogFired = useSettleWatchdog(isAuthSettled, SPLASH_TIMING.watchdog);
  const isFlagUnreachable = isAuthInitializationError || isAuthWatchdogFired || !hasToken;

  useMemo(() => applyUIVariantQueryOverride(), []);

  return useMemo(() => {
    if (!isAuthSettled && !isFlagUnreachable) {
      return {variant: DEFAULT_UI_VARIANT, isResolved: false};
    }

    const flag = getFeatureFlags('GUESTAPP_REDESIGN_ENABLED');

    if (flag === undefined && isFlagUnreachable) {
      return {variant: UI_VARIANTS.redesign, isResolved: true};
    }

    return {
      variant: flag ? UI_VARIANTS.redesign : UI_VARIANTS.classic,
      isResolved: true,
    };
  }, [isAuthSettled, isFlagUnreachable]);
}
